import type { ReactNode } from 'react'

// Left-hand facet column shared by both Operations modes (our operations, All Atlassian API).

export function FacetGroup({ title, children, scroll }: {
  title: string
  children: ReactNode
  /** long lists (Atlassian categories) scroll inside the group */
  scroll?: boolean
}) {
  return (
    <div role="group" aria-label={title} className={scroll ? 'flex min-h-0 flex-col pb-2' : 'pb-2'}>
      <div className="shrink-0 px-3 pb-1 pt-2 text-[11px] font-medium uppercase tracking-[0.06em] text-text-3" aria-hidden>
        {title}
      </div>
      {scroll ? <div className="min-h-0 overflow-y-auto">{children}</div> : children}
    </div>
  )
}

export function Facet({ label, count: n, active, mono, onClick }: {
  label: string
  count: number
  active: boolean
  mono?: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      title={label}
      className={[
        'flex h-[26px] w-full items-center justify-between gap-2 border-l-2 pl-[10px] pr-3 text-left text-[12.5px] transition-colors',
        active
          ? 'border-primary bg-surface-selected text-foreground'
          // nothing left behind this value with the other filters: quieter, still clickable
          : `border-transparent hover:bg-line-row hover:text-foreground ${n === 0 ? 'text-text-3' : 'text-text-2'}`,
      ].join(' ')}
    >
      <span className={`truncate ${mono ? 'font-mono text-[12px]' : ''}`}>{label}</span>
      <span className="font-mono text-[11px] tabular-nums text-text-3">{n}</span>
    </button>
  )
}

export function ClearFilters({ onClick }: { onClick: () => void }) {
  return (
    <div className="shrink-0 px-3 pb-2 pt-1">
      <button
        type="button"
        onClick={onClick}
        className="text-[12px] text-text-2 underline decoration-line-strong underline-offset-4 transition-colors hover:text-foreground"
      >
        Clear filters
      </button>
    </div>
  )
}
